'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'https://wa.cdn-surfline.com/quiver/0.11.1';


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-assets/dist/index.js
// module id = 52
// module chunks = 11